import { Box } from "@mui/material";
import React, { useContext } from "react";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { useWalletContext } from "../../../../context/WalletContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./PackageDetail.module.css";

const buildDetailsRow = (packageData = {}, I18n = {}) => {
  if (Array.isArray(packageData.details) && packageData.details.length > 0) {
    return packageData.details;
  }

  // Fallback if API sends flat fields instead of details[]
  return [
    {
      value: packageData.on_net_mins ?? packageData.onnet ?? packageData.on_net,
      label: packageData.on_net_label || I18n.on_net_mins,
    },
    {
      value:
        packageData.off_net_mins ?? packageData.offnet ?? packageData.other_net,
      label: packageData.off_net_label || I18n.other_net_mins || "Other net mins",
    },
    {
      value: packageData.sms ?? packageData.all_net_sms,
      label: packageData.sms_label || I18n.all_net_sms || "All net SMS",
    },
    {
      value: packageData.data ?? packageData.data_gb ?? packageData.gbs,
      label: packageData.data_label || I18n.gbs_data,
    },
  ].filter(
    (item) => item.value !== undefined && item.value !== null && item.value !== "",
  );
};

const PackageDetail = ({ packageData = {}, onSelect, isSelectedPackage }) => {
  const [I18n] = useContext(LanguageContext);
  const { walletData } = useWalletContext();
  const balance = walletData?.current_balance || 0;

  const handleSelect = () => {
    triggerLogEvent(analytics, "w_earn_ep_package_detail", {
      offer_name: packageData.offer_name,
      price: packageData.price,
    });
    if (onSelect) onSelect(packageData);
  };

  const {
    offer_name = I18n.all_in_one_weekly,
    offer = "",
    info = "",
    price,
    old_price,
    validity = "",
  } = packageData;

  const details = buildDetailsRow(packageData, I18n);
  const isDisabled = (balance || 0) < (price || 0);


  return (
    <Box
      id={`easyload_package_card_${packageData.offer_key ?? packageData.id ?? offer_name}`}
      className={`${styles.packageCard} ${
        isSelectedPackage ? styles.packageCardSelected : ""
      }`}
    >
      {isDisabled && (
        <Box className={styles.insufficientAlert}>
          <ParagraphText className="fontSize12">
            {I18n.balance_insufficient}
          </ParagraphText>
        </Box>
      )}

      <Box className={styles.packageCardHeader}>
        <ParagraphText className={styles.packageName}>{offer_name}</ParagraphText>
        {offer ? <span className={styles.offerTag}>{offer}</span> : null}
      </Box>

      {details.length > 0 ? (
        <Box className={styles.featuresRow}>
          {details.map((item, index) => (
            <Box key={index} className={styles.featureItem}>
              <ParagraphText className={styles.featureValue}>
                {item.value}
              </ParagraphText>
              <ParagraphText className={styles.featureLabel}>
                {item.label}
              </ParagraphText>
            </Box>
          ))}
        </Box>
      ) : null}

      <Box className={styles.divider} aria-hidden="true" />

      {info ? (
        <ParagraphText className={styles.infoText}>{info}</ParagraphText>
      ) : null}

      <Box className={styles.packageFooter}>
        <Box className={styles.priceBlock}>
          <ParagraphText className={styles.priceText}>
            <span>Rs. {formatNum(price)}</span>
            {old_price ? (
              <span className={styles.oldPrice}>Rs. {formatNum(old_price)}</span>
            ) : null}
          </ParagraphText>
          {validity ? (
            <ParagraphText className={styles.validityText}>
              {I18n.validity}: {validity}
            </ParagraphText>
          ) : null}
        </Box>

        <UBButton
          title={I18n.select}
          id="package_select_btn"
          onClick={handleSelect}
          disabled={isDisabled}
          className={`textUppercase ubPrimaryButton ${styles.selectButton}`}
        />
      </Box>
    </Box>
  );
};

export default PackageDetail;
